module.exports = __webpack_public_path__ + "img/landing-general-info-screen-1.03cf849a.png";